/**
 * New In – Tabs + Product Slider with Embla Carousel
 */
(function () {
  // Embla Product Slider Class
  class EmblaProductSlider {
    constructor(element) {
      this.slider = element;
      this.viewport = element.querySelector('.slider-viewport');
      this.emblaNode = this.viewport;
      this.prevBtn = element.querySelector('.slider-arrow-prev');
      this.nextBtn = element.querySelector('.slider-arrow-next');

      // Embla options
      this.options = {
        loop: true,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        slidesToScroll: 1,
        skipSnaps: true
      };

      this.emblaApi = null;
      this.init();
    }

    async init() {
      const EmblaCarousel = await this.loadEmbla();
      this.emblaApi = EmblaCarousel(this.emblaNode, this.options);
      this.setupButtons();
      this.emblaApi.on('select', () => this.updateButtonStates());
      this.updateButtonStates();
    }

    async loadEmbla() {
      if (window.EmblaCarousel) return window.EmblaCarousel;
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/embla-carousel@8.6.0/embla-carousel.umd.js';
        script.onload = () => resolve(window.EmblaCarousel);
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    setupButtons() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          if (this.emblaApi) this.emblaApi.scrollPrev();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          if (this.emblaApi) this.emblaApi.scrollNext();
        });
      }
    }

    updateButtonStates() {
      if (!this.emblaApi) return;
      const canScrollPrev = this.emblaApi.canScrollPrev();
      const canScrollNext = this.emblaApi.canScrollNext();
      if (this.prevBtn) this.prevBtn.disabled = !canScrollPrev;
      if (this.nextBtn) this.nextBtn.disabled = !canScrollNext;
    }

    destroy() {
      if (this.emblaApi) this.emblaApi.destroy();
    }
  }

  const initializedRoots = new WeakSet();

  function setupRoot(root) {
    if (initializedRoots.has(root)) return;
    const tabs = root.querySelectorAll('.ni-tab');
    const panels = root.querySelectorAll('.ni-panel');
    const initializedSliders = new Map();

    function activate(id) {
      tabs.forEach((t) => {
        t.classList.toggle('is-active', t.getAttribute('data-ni-tab') === id);
      });
      panels.forEach((p) => {
        const isActive = p.id === id;
        p.classList.toggle('is-active', isActive);
        if (isActive && !initializedSliders.has(p.id)) {
          const sliderElement = p.querySelector('.product-slider');
          if (sliderElement) {
            initializedSliders.set(p.id, new EmblaProductSlider(sliderElement));
          }
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activate(tab.getAttribute('data-ni-tab'));
      });
    });

    const firstActivePanel = root.querySelector('.ni-panel.is-active');
    if (firstActivePanel) activate(firstActivePanel.id);

    initializedRoots.add(root);
  }

  function setupRootsIn(node) {
    if (!node || node.nodeType !== 1) return;
    const found = [];
    if (node.matches && node.matches('section[id^="new-in-"]')) {
      found.push(node);
    }
    node.querySelectorAll &&
      found.push(...node.querySelectorAll('section[id^="new-in-"]'));
    found.forEach(setupRoot);
  }

  // Initial pass for existing sections
  setupRootsIn(document.documentElement || document);

  // Observe dynamically added sections (e.g., product recommendations injected via AJAX)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        setupRootsIn(n);
      }
    }
  });
  observer.observe(document.documentElement || document, {
    childList: true,
    subtree: true,
  });

  // Optional manual trigger: window.NewInInit(root?)
  window.NewInInit = function (root) {
    setupRootsIn(root || document.documentElement || document);
  };
})();
